import { ReactElement } from 'react';

import { BlockedChatHeader } from '../blockedChat/blockedChatHeader';
import { ContentContainer } from '../layout/contentContainer';
import { HeaderContainer } from '../layout/headerContainer';
import { ErrorShowcaseContainer } from './errorShowcaseContainer';

//если обновим на react18, то попробовать root.unmount() для автоматического обновления чата
export const ErrorFallback = (): ReactElement => {
	return (
		<>
			<HeaderContainer hasError>
				<BlockedChatHeader />
			</HeaderContainer>
			<ContentContainer>
				<ErrorShowcaseContainer />
			</ContentContainer>
		</>
	);
};
